import { PropTypes } from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import VisuallyHidden from '@zenbusiness/zui/VisuallyHidden';

import Fieldset from '#client/components/Fieldset';

import EmailField from './components/EmailField';
import PasswordField from './components/PasswordField';

function AccountFieldset({ fieldsConfig, namePrefix }) {
  const { formState } = useFormContext();
  const { isSubmitting } = formState;

  const { email, password } = fieldsConfig || {};
  const { show: showEmail, ...emailProps } = email || {};
  const { show: showPassword, ...passwordProps } = password || {};

  const MESSAGE_IDS = {
    legend: 'shopping.component.accountFieldset.legend',
    email: {
      label: 'shopping.component.accountFieldset.email.heading'
    },
    password: {
      label: 'shopping.component.accountFieldset.password.heading'
    }
  };

  return (
    <Fieldset disabled={isSubmitting} spacing={2.5}>
      <VisuallyHidden as="legend">
        <FormattedMessage id={MESSAGE_IDS.legend} />
      </VisuallyHidden>

      {showEmail && (
        <Stack spacing={1.5}>
          <Heading component="h3" size="md" weight="medium">
            <FormattedMessage id={MESSAGE_IDS.email.label} />
          </Heading>
          <EmailField {...emailProps} namePrefix={namePrefix} />
        </Stack>
      )}

      {showPassword && (
        <Stack spacing={1.5}>
          <Heading component="h3" size="md" weight="medium">
            <FormattedMessage id={MESSAGE_IDS.password.label} />
          </Heading>
          <PasswordField {...passwordProps} namePrefix={namePrefix} />
        </Stack>
      )}
    </Fieldset>
  );
}

AccountFieldset.propTypes = {
  fieldsConfig: PropTypes.shape({
    email: PropTypes.object,
    password: PropTypes.object
  }).isRequired,
  namePrefix: PropTypes.string
};

export default AccountFieldset;
